// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthPage_root__q66Qx","backgroundContainer":"AuthPage_backgroundContainer__2v6e2","header":"AuthPage_header__TYO1i"};